module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"v":"Votre abonnement a été créé avec succès.","w":"Vous pouvez désormais entièrement bénéficier de nos services.","x":"Créer un nouveau dossier"},"en":{"v":"Your subscription was successfully created.","w":"You can now fully use our services.","x":"Transform a new CV"}}')
  delete Component.options._Ctor
}
